import { Container, Row, Col, Image } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { FaPercentage, FaHandsHelping, FaQuestionCircle, FaCertificate, FaHistory } from "react-icons/fa";
import "./FerramentasPage.scss";

import ferramentasBg from "./img/ferramentas-bg.png";
import ferramentasImg from "./img/FERRAMENTAS - 1.png";
import ferramentasGruposImg from "./img/celular-ferramentas.png";
import ferramentasCategoriesImg from "./img/ferramentas-fita.png";
import ferramentasFitaImg from "./img/ferramentas-fita.png";
import logo from './img/logo-main.png';

const baseURL = process.env.NODE_ENV === "production"
  ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
  : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;

const whatsappLink = `${baseURL}entrar?tipo=ferramentas`;

export default function FerramentasPage() {
  return (
    <div className="ferramentas-page">
      <Helmet title="Grupo FERRAMENTAS - Caçadores de Ofertas" />

      <section
        className="ferramentas-hero"
        style={{
          backgroundImage: `url("${ferramentasBg}")`
        }}
      >
        <div className="ferramentas-hero-inner">
          <div className="ferramentas-hero-left">
            <h1 className="ferramentas-title">
              FERRAMENTAS
            </h1>

            <div className="ferramentas-subtitle">
              O grupo que faltava pro dono de casa!
            </div>

            <button
              className="ferramentas-hero-cta"
              onClick={() => {
                const section = document.querySelector(".ferramentas-cta");
                if (section) section.scrollIntoView({ behavior: "smooth" });
              }}
            >
              QUERO PARTICIPAR
            </button>
          </div>

          <div className="ferramentas-hero-right">
            <img
              src={ferramentasImg}
              alt="Capacete e ferramentas"
              className="ferramentas-hero-img"
            />
          </div>

          <img
            src={ferramentasFitaImg}
            alt=""
            aria-hidden="true"
            className="ferramentas-hero-tape"
          />
        </div>
      </section>

      <section className="ferramentas-cta">
        <div className="ferramentas-cta__card">
          <div className="ferramentas-cta__phone">
            <img src={ferramentasGruposImg} alt="Celular mostrando o grupo de ofertas Ferramentas no WhatsApp" />
          </div>
          <div className="ferramentas-cta__content">
            <h2>Falta pouco!</h2>
            <p>Clique no botão abaixo para participar:</p>
            <a href={whatsappLink} rel="noopener noreferrer" className="ferramentas-cta__button">WhatsApp</a>
          </div>
        </div>
      </section>

      <section className="section-vantagens">
        <Container>
          <h2 className="title-vantagens text-center mb-5">QUAIS AS VANTAGENS?</h2>
          <Row className="text-center justify-content-center gx-4 gy-4">
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card white flex-fill">
                <div className="icon-wrapper yellow-bg">
                  <FaCertificate className="icon-back" />
                  <FaPercentage className="icon-front" />
                </div>
                <h3>Promoções diárias</h3>
                <p>Receba no conforto da sua casa as melhores promoções dos principais varejistas do Brasil!</p>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card yellow flex-fill">
                <div className="icon-wrapper custom-blue-bg">
                  <FaHandsHelping className="icon white large" />
                </div>
                <h3>Apoio na compra</h3>
                <p>Conte conosco para garantir que fará uma excelente compra, com segurança e pagando barato!</p>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card white flex-fill">
                <div className="icon-wrapper yellow-bg">
                  <div className="icon-back-circle" />
                  <FaQuestionCircle className="icon-front question-icon" />
                </div>
                <h3>Tire suas dúvidas</h3>
                <p>Tá com alguma dúvida sobre alguma oferta? Entre em contato conosco que iremos lhe ajudar!</p>
              </div>
            </Col>
            <Col xs={12} sm={6} md={3} className="d-flex">
              <div className="vantagem-card yellow flex-fill">
                <div className="icon-wrapper white-bg">
                  <FaHistory className="icon white large" />
                </div>
                <h3>Histórico de preços</h3>
                <p>Tá em dúvida se um produto tá barato? Confira nosso histórico de preços no Telegram!</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="section-quem-somos">
        <div className="container">
          <Row className="align-items-center">
            <Col xs={12}>
              <h2 className="title-quem-somos text-center">QUEM SOMOS?</h2>
            </Col>
            <Col xs={12} md={6}>
              <div className="video-container">
                <iframe src="https://www.youtube.com/embed/VY2NEogxHVk" title="YouTube" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="quem-somos-text">
                <p>Nascemos em 2020 com objetivo de ajudar os consumidores brasileiros a economizar em suas compras na internet!</p>
                <p>Contamos com grupos de ofertas gerais no WhatsApp e Telegram, com mais de 200 mil membros totais, além de mais de 100 mil inscritos no YouTube!</p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <div className="footer">
        <Container className="text-center">
          <Image src={logo} alt="Caçadores de Ofertas" className="footer-logo" />
          <br /><br />
          <p className="footer-text">© Caçadores de Ofertas 2022-2025<br />Todos os direitos reservados.</p>
        </Container>
      </div>

    </div>
  );
}
